import type { ReturnPreviewItemProps } from '@services/api/preview/types'
import { getAccountLabelFromAccountId } from '@pages/Preview/components/modals/ReturnPreviousModal/constants/returnPreviewAccountOptions'

/**
 * Monta os valores iniciais do formulário.
 * @param data - Dados da linha do grid (economicGroup, profitCenter, budget, etc.)
 * @param returnItems - Itens retornados por GET /api/previaapproval/return (quando informado, preenche accounts)
 */
export const setInitialValues = (data: any, returnItems?: ReturnPreviewItemProps[]) => {
  const parsedData = {
    economicGroup: data?.economicGroup ?? '',
    profitCenter: data?.profitCenter ?? '',
    budget: data?.budget ?? '',
    actualPreview: data?.actualPreview ?? '',
    deviationVsBudget: data?.deviationVsBudget ?? '',
    accounts:
      returnItems && returnItems.length > 0
        ? returnItems.map((item) => ({
            account: getAccountLabelFromAccountId(item.accountId),
            returnJustification: item.justification ?? '',
            userAndProfile: [item.submittedBy, item.profileCode].filter(Boolean).join(' - ') || '',
            dateAndTime: item.submittedAt ?? item.createdAt ?? '',
            validationPossibleUntil: item.deadlineDate ?? ''
          }))
        : data?.accounts?.length > 0
          ? data.accounts.map((account: any) => ({
              account: account.account || account.accountCode || account.name || '',
              returnJustification: account.returnJustification ?? account.justification ?? '',
              userAndProfile: account.userAndProfile ?? account.user ?? '',
              dateAndTime: account.dateAndTime ?? account.returnDate ?? '',
              validationPossibleUntil: account.validationPossibleUntil ?? account.validationDeadline ?? ''
            }))
          : [
              {
                account: '',
                returnJustification: '',
                userAndProfile: '',
                dateAndTime: '',
                validationPossibleUntil: ''
              }
            ]
  }

  return parsedData
}
